export const VIBE_PROJECT_DELETE_POLL_INTERVAL = 3000

export const VIBE_PROJECT_DELETE_STATUS_META = {
    pending: { text: '等待执行', color: 'orange' },
    running: { text: '删除中', color: 'processing' },
    failed: { text: '删除失败', color: 'red' },
    completed: { text: '删除完成', color: 'green' },
}

export const VIBE_PROJECT_DELETE_STEP_META = {
    server_cleanup: '清理服务器部署、Docker 容器和 Nginx 配置',
    database_grants_cleanup: '回收项目数据库授权',
    physical_storage_cleanup: '删除独立数据库或数据集受管物理表',
    oss_cleanup: '删除项目 OSS 文件',
    inventory_cleanup: '删除部署清单',
    gitlab_project_cleanup: '永久删除 GitLab 项目',
    metadata_cleanup: '删除项目权限、日志和业务元数据',
    completed: '全部清理完成',
}

export const VIBE_PROJECT_DELETE_RESOURCE_META = [
    ['grantCount', '数据库授权关系'],
    ['grantLogCount', '数据库授权日志'],
    ['ossObjectCount', 'OSS 文件'],
    ['permissionRequestCount', '权限申请'],
    ['provisionLogCount', '接入日志'],
    ['projectApiCount', '项目 API'],
    ['projectApiRoleCount', '项目 API 角色'],
    ['datasetCount', '数据集配置'],
    ['datasetAclCount', '数据集授权'],
    ['datasetAccessRequestCount', '数据集访问申请'],
]

function isTrue(value) {
    return value === true || value === 1 || value === '1' || String(value).toLowerCase() === 'true'
}

export function canDeleteVibeProject(project, userInfo) {
    if (!project || !userInfo) return false
    if (isTrue(project.isOwner)) return true

    const currentUserId = userInfo.userId ?? userInfo.id
    return currentUserId !== undefined
        && currentUserId !== null
        && currentUserId !== ''
        && project.ownerUserId !== undefined
        && project.ownerUserId !== null
        && project.ownerUserId !== ''
        && String(currentUserId) === String(project.ownerUserId)
}

export function isVibeProjectDeleteTask(value) {
    return Boolean(value && value.status && !value.project)
}

export function isVibeProjectDeleteActive(status) {
    return status === 'pending' || status === 'running'
}

export function isVibeProjectDeleteCompleted(status) {
    return status === 'completed'
}

export function canRetryVibeProjectDelete(status) {
    return status === 'failed'
}

export function getVibeProjectDeleteConfirmation(preview, fallbackProject) {
    return preview?.confirmation
        || preview?.project?.projectSlug
        || preview?.projectSlug
        || fallbackProject?.projectSlug
        || ''
}

export function getVibeProjectDeleteStepText(step) {
    return VIBE_PROJECT_DELETE_STEP_META[step] || step || '-'
}

export function getVibeProjectDeleteResourceItems(resourceCounts = {}) {
    return VIBE_PROJECT_DELETE_RESOURCE_META
        .map(([key, label]) => ({ key, label, count: Number(resourceCounts[key]) || 0 }))
        .filter(item => item.count > 0)
}
